import CreatePayment from './create-payment';
import { postData } from './fetch';

window.addEventListener('load', () => {
  const cardForm = document.querySelector('.card-form');
  const cardSubmit = document.querySelector('.card-submit');
  const cardIdInput = document.querySelector('.card-id-input');
  const amountInput = document.querySelector('.amount-input');
  const streetIdInput = document.querySelector('.streetid-input');
  const organizationIdInput = document.querySelector('.organizationid-input');
  const houseInput = document.querySelector('.house-input');
  const paymentTypeInput = document.querySelector('.paymenttype-input');
  const floorInput = document.querySelector('.floor-input');
  const entranceInput = document.querySelector('.entrance-input');
  const orderIdInput = document.querySelector('.order-input');
  const commentInput = document.querySelector('.comment-input');
  const deliveryTimeInput = document.querySelector('.delivery-time-input');
  const pickupTimeInput = document.querySelector('.pickup-time-input');
  const cardErrorsList = document.querySelector('.card-error-list');
  const cardInputs = document.querySelectorAll('.card-input');
  const cardHolderHiddenInput = document.querySelector(
    '.card-holder-hidden-name',
  );
  const locatorNumberInput = document.querySelector('.locator-input');
  const alertBtn = document.querySelector('.alert-btn');
  const cardsBackLink = document.querySelector('.cards-back-link');
  const alertPopupOverlay = document.querySelector('.alert-popup-overlay');
  const alertPopupCloseBtn = document.querySelector('.close-alert-popup');

  const setPaymentsErrors = (errors) => {
    const messages = errors.map((message) => `<li>${message}</li>`);

    cardErrorsList.innerHTML = messages.join('');
  };

  if (cardInputs) {
    [].forEach.call(cardInputs, (input) => {
      if (input.classList.contains('disabled')) {
        input.classList.remove('disabled');
      }
    });
  }

  const createPaymentByCard = async (cardId, orderId, name, amount) => {
    const body = {
      cardId,
      orderId,
      name,
      amount,
    };

    const response = await postData('/payments/create', body);

    if (response) {
      if (response.statusCode === 400) {
        cardSubmit.classList.remove('loading');

        if (cardErrorsList) {
          if (response.errors) {
            setPaymentsErrors(response.errors);
          }
        }

        if (cardInputs) {
          [].forEach.call(cardInputs, (input) =>
            input.classList.remove('disabled'),
          );
        }
      } else {
        if (response.data && response.data.id) {
          window.location.href = `/profile/orders/${response.data.id}`;
        }
      }
    }
  };

  let formValues = {};
  const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

  if (formValuesFromSessionStorage) {
    formValues = JSON.parse(formValuesFromSessionStorage);
  }

  if (formValues && Object.keys(formValues).length) {
    if (formValues.orderId) {
      if (cardsBackLink) {
        cardsBackLink.classList.add('hidden');
      }

      if (alertBtn) {
        alertBtn.classList.remove('hidden');
      }

      if (alertPopupOverlay) {
        alertPopupOverlay.setAttribute(
          'href',
          `/profile/orders/${formValues.orderId}`,
        );
      }

      if (alertPopupCloseBtn) {
        alertPopupCloseBtn.setAttribute(
          'href',
          `/profile/orders/${formValues.orderId}`,
        );
      }
    }
  }

  if (cardForm) {
    cardForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      let amount;
      let house;
      let paymentType;
      let deliveryTime;
      let pickupTime;
      let streetId;
      let organizationId;
      let floor;
      let flat;
      let entrance;
      let comment;
      let cardId;
      let locatorNumber;

      if (amountInput) {
        amount = amountInput.value;
      }

      if (paymentTypeInput) {
        paymentType = paymentTypeInput.value;
      }

      if (streetIdInput) {
        streetId = streetIdInput.value;
      }

      if (organizationIdInput) {
        organizationId = organizationIdInput.value;
      }

      if (deliveryTimeInput) {
        deliveryTime = deliveryTimeInput.value;
      }

      if (pickupTimeInput) {
        pickupTime = pickupTimeInput.value;
      }

      if (houseInput) {
        house = houseInput.value;
      }

      if (floorInput) {
        floor = floorInput.value;
      }

      if (entranceInput) {
        entrance = entranceInput.value;
      }

      if (commentInput) {
        comment = commentInput.value;
      }

      if (locatorNumberInput) {
        locatorNumber = locatorNumberInput.value;
      }

      cardSubmit.classList.add('loading');

      const body = {
        paymentType,
      };

      if (streetId) {
        body.type = 'delivery';
        body.streetId = streetId;
      }

      if (organizationId) {
        body.type = 'delivery-togo';
        body.organizationId = organizationId;
      }

      if (deliveryTime && deliveryTime !== 'Как можно скорее') {
        body.deliveryTime = deliveryTime;
      }

      if (pickupTime && pickupTime !== 'Как можно скорее') {
        body.pickupTime = pickupTime;
      }

      if (house) {
        body.house = house;
      }

      if (floor) {
        body.floor = floor;
      }

      if (flat) {
        body.flat = flat;
      }

      if (entrance) {
        body.entrance = entrance;
      }

      if (comment) {
        body.comment = comment;
      }

      if (locatorNumber) {
        body.locatorNumber = locatorNumber;
      }

      if (cardIdInput && cardIdInput.value) {
        cardId = cardIdInput.value;
      }

      let orderId;

      if (formValues && Object.keys(formValues).length) {
        if (formValues.orderId) {
          orderId = formValues.orderId;
        }
      } else {
        if (orderIdInput) {
          orderId = orderIdInput.value;
        }
      }

      if (amount) {
        formValues.amount = amount;
      }

      if (cardInputs) {
        [].forEach.call(cardInputs, (input) => input.classList.add('disabled'));
      }

      if (!orderId) {
        const response = await postData('/order/create', body);

        if (response) {
          if (response.statusCode === 400 || response.errors) {
            cardSubmit.classList.remove('loading');

            if (cardErrorsList) {
              if (response.errors) {
                setPaymentsErrors(response.errors);
              }
            }

            if (cardInputs) {
              [].forEach.call(cardInputs, (input) =>
                input.classList.remove('disabled'),
              );
            }
          } else if (response.statusCode === 200) {
            if (response.data.id) {
              const {
                id: orderId,
                originalDeliveryTime,
                deliveryTime,
                userId,
                userPhone,
                userEmail,
              } = response.data;

              formValues.orderId = orderId;
              formValues.userId = userId;
              formValues.userPhone = userPhone;
              formValues.userEmail = userEmail;

              document.cookie = `orderId=${orderId};path=/;max-age=3600`;

              if (originalDeliveryTime !== deliveryTime) {
                const orderChanges = {};

                orderChanges.deliveryTime = deliveryTime;

                if (streetId) {
                  orderChanges.type  = 'delivery';
                }

                if (organizationId) {
                  orderChanges.type = 'delivery-togo';
                }

                if (sessionStorage) {
                  sessionStorage.setItem('orderChanges', JSON.stringify(orderChanges));
                }
              }

              if (sessionStorage) {
                sessionStorage.setItem(
                  'formValues',
                  JSON.stringify(formValues),
                );
              }

              if (cardsBackLink) {
                cardsBackLink.classList.add('hidden');
              }

              if (alertBtn) {
                alertBtn.classList.remove('hidden');
              }

              if (alertPopupOverlay) {
                alertPopupOverlay.setAttribute(
                  'href',
                  `/profile/orders/${orderId}`,
                );
              }

              if (alertPopupCloseBtn) {
                alertPopupCloseBtn.setAttribute(
                  'href',
                  `/profile/orders/${orderId}`,
                );
              }

              if (!cardId) {
                CreatePayment({
                  orderId,
                  userPhone,
                  userEmail,
                  userId,
                  amount,
                });
              } else {
                createPaymentByCard(
                  cardId,
                  orderId,
                  cardHolderHiddenInput.value,
                  amount,
                );
              }
            }
          }
        }
      } else {
        if (!cardId) {
          const {
            userPhone,
            userEmail,
            userId,
          } = formValues || {};

          CreatePayment({
            orderId,
            userPhone,
            userEmail,
            userId,
            amount,
          });
        } else {
          createPaymentByCard(
            cardId,
            orderId,
            cardHolderHiddenInput.value,
            amount,
          );
        }
      }
    });
  }
});
